import { render, staticRenderFns } from "./ElementScaleManualPartTableColumn.vue?vue&type=template&id=6b2cf8f6&scoped=true"
import script from "./ElementScaleManualPartTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScaleManualPartTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementScaleManualPartTableColumn.vue?vue&type=style&index=0&id=6b2cf8f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2cf8f6",
  null
  
)

export default component.exports